import { type BasketItem, type SimplifiedBasketItem } from "./types";

const availabilityStatuses = ["PREORDERABLE", "INSTOCK"];

export const getBasketItems = (
  commerceItems: BasketItem[] = [],
  pimProductId: string,
): SimplifiedBasketItem[] => {
  const matchedItems = commerceItems.filter(
    ({ productId, availabilityStatus }) => {
      return (
        productId === pimProductId &&
        availabilityStatus !== undefined &&
        availabilityStatuses.includes(availabilityStatus)
      );
    },
  );

  const result: SimplifiedBasketItem[] = [];

  matchedItems.forEach((item) => {
    const { id, name, quantity, childItems = [], skuId, price } = item;
    result.push({
      id,
      skuId,
      title: name,
      quantity: quantity.toString(),
      price,
    });

    childItems.forEach((childItem) => {
      result.push({
        id: childItem.id,
        skuId: childItem.skuId,
        title: childItem.name,
        quantity: childItem.quantity.toString(),
        price: childItem.price,
      });
    });
  });

  return result;
};
